module.exports = __webpack_public_path__ + "static/media/carousel7.785ddbd4.jpeg";